import { atom } from 'jotai';
import type { InviteShareRes } from '@/types/api/user-agent/invite-share';
import type { PosterApi } from '@/features/referral/components/base/Poster';

/**
 * 代理活动是否下架的状态
 * true: 已下架, false: 正常上线
 */
export const isReferralActivityOfflineAtom = atom<boolean>(false);

/**
 * 邀请码
 */
export const inviteCodeAtom = atom<string | undefined>(undefined);

/**
 * 分享配置数据
 */
export const shareConfigDataAtom = atom<InviteShareRes | undefined>(undefined);

/**
 * 海报的ref
 */
export const downloadPosterRefAtom = atom<React.MutableRefObject<PosterApi | null> | null>(null);

/**
 * 是否需要渲染下载用 Poster
 */
export const shouldRenderDownloadPosterAtom = atom<boolean>(false);

/**
 * 设置邀请码的派生 atom
 */
export const setInviteCodeAtom = atom(
  null,
  (_get, set, inviteCode: string | undefined) => {
    set(inviteCodeAtom, inviteCode);
  }
);

/**
 * 设置分享配置数据的派生 atom
 */
export const setShareConfigDataAtom = atom(
  null,
  (_get, set, shareConfigData: InviteShareRes | undefined) => {
    set(shareConfigDataAtom, shareConfigData);
  }
);
